module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/zh-hant_4-1c6c7f99ef0d21e8ee7b69fbeff9d333.jpg";